// src/pages/MainCategoryPage.jsx
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../contexts/CartContext';
import Header from '../components/layout/Header';
import beerBackground from '../assets/images/beer-background.jpg';
import sodaBackground from '../assets/images/soda-background.jpg';
import '../styles/main-category.css';
import SEOHead from '../components/SEO/SEOHead';

const MainCategoryPage = () => {
  const navigate = useNavigate();
  const { getTotalItems } = useContext(CartContext);
  
  const handleCategorySelect = (category) => {
    if (category === 'beer') {
      navigate('/beer');
    } else if (category === 'beverages') {
      navigate('/prototype-categories');
    }
  };
  
  return (
    <div className="category-page">
    <SEOHead
      title="Nos catégories de boissons"
      description="Découvrez nos catégories : bières, vins, spiritueux, eaux minérales, boissons gazeuses."
      canonical="https://bccv.online/categories"
    />
      <Header title="Que souhaitez-vous commander ?" />
      
      <div className="category-content">
        <h1 className="content-title">Choisissez une catégorie</h1>
        <p className="content-subtitle">
          Commandez vos boissons ici et faites vous livrer à domicile
        </p>
        
        <div className="categories-container">
          {/* Option Eaux & Boissons Gazeuses */}
          <div 
            className="category-item"
            onClick={() => handleCategorySelect('beverages')}
            style={{ backgroundImage: `url(${sodaBackground})` }}
          >
            <div className="category-overlay">
              <h2 className="category-title">EAUX & BOISSONS GAZEUSES</h2>
              <p className="category-description">Rafraîchissez-vous avec nos boissons gazeuses et eaux minérales</p>
            </div>
          </div>
          
          {/* Option Bière à Pression */}
          <div 
            className="category-item"
            onClick={() => handleCategorySelect('beer')}
            style={{ backgroundImage: `url(${beerBackground})` }}
          >
            <div className="category-overlay">
              <h2 className="category-title">BIÈRE À PRESSION</h2>
              <p className="category-description">Découvrez notre sélection de bières artisanales</p>
            </div>
          </div>
        </div>
        
        {/* Bouton du panier (visible uniquement si non vide) */}
        {getTotalItems() > 0 && (
          <button 
            onClick={() => navigate('/cart')}
            className="cart-button"
          >
            <svg className="cart-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 20a1 1 0 11-2 0 1 1 0 012 0zm9 0a1 1 0 11-2 0 1 1 0 012 0zM3 3h2l.4 2M7 13h10l4-8H5.4L3 3" />
            </svg>
            Voir mon casier ({getTotalItems()} articles)
          </button>
        )}
      </div>
    </div>
  );
};

export default MainCategoryPage;